import { useCallback, useEffect, useState } from 'react';

import { extractTrendUiErrorMessage } from '../errorUtils';
import { fetchTrendReports } from '../service';
import type { TrendReport } from '../types';

export function useTrendsReports(status?: string) {
  const [reports, setReports] = useState<TrendReport[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setReports(await fetchTrendReports(status));
    } catch (err: any) {
      setError(extractTrendUiErrorMessage(err, 'Kunde inte ladda trendrapporter.'));
    } finally {
      setLoading(false);
    }
  }, [status]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { reports, loading, error, reload, setReports };
}
